
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-prefield\">\n    <div class=\"c-appointment\">\n        <div class=\"starttext\">\n            本场直播将于")
    ; __append(escape(starttime))
    ; __append("开始\n            <div class=\"appointment\">\n                ")
    ;  if (hasApp) { 
    ; __append("\n                <div class=\"appbtn showApp\">\n                    <span class=\"text\">开启提醒</span>\n                </div>\n                ")
    ;  }else{ 
    ; __append("\n                <div class=\"appbtn hideApp\">\n                    <span class=\"text\">关闭提醒</span>\n                </div>\n                ")
    ;  } 
    ; __append("\n            </div>\n        </div>\n    </div>\n    <div class=\"split\"></div>\n</div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/notice/notice.ejs
// module id = 525
// module chunks = 0